export function sprintf(format, ...args) {
  let argIndex = 0;
  // Use a Regex to find placeholders like %s, %d, %f
  return format.replace(/%([sdif])/g, (match, type) => {
    const value = args[argIndex++];

    if (value === undefined) {
      console.warn(`jsSprintf: Missing argument for placeholder '${match}'`);
      return match;
    }
    // Basic type handling
    switch (type) {
      case "s": // String
        return String(value);
      case "d": // Integer (coerced)
        return parseInt(value, 10).toString();
      case "i": // Alias for 'd'
        return parseInt(value, 10).toString();
      case "f": // Float (simple coercion, does not handle precision)
        return parseFloat(value).toString();
      default:
        return match;
    }
  });
}
